export const meta = {
    data: {
        title: '',
        code: '',
        originCode: '', // origin Word or other doc
        author: 'Example Author',
        description: '',
        keywords: 'Templating, PDF',
        subject: '',
        changeLog: '',
        version: '1.0',
    },
    footer: `
<div id="footer" style="color: #888888;">
    Example company<br />
    Tel.: <a href="tel:+420123456789">123 456 789</a>, e-mail: <a href="mailto:info@domain.tld">info@domain.tld</a>, <a href="https://www.domain.tld" target="_blank">www.domain.tld</a><br />
</div>
    `,
};
